import React from "react"
import ImageUpload from "./../general/ImageUpload"
import { has } from "lodash"

class ImageForm extends React.Component {
    constructor(){
        super()
        this.state = {
            remoteImages: null
        }
    }
    componentDidMount(){
        this.GetRemoteImageList(this.props.projectId, this.props.appConfig[0].id);
    }
    GetRemoteImageList(projectId, appConfigId) {
        fetch(`/api/data/project/${projectId}/appConfig/${appConfigId}/remoteImage/list`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")) { throw data }
            if (this.state.remoteImages === null || this.state.remoteImages.length !== data.result.length) {
                this.setState({remoteImages: data.result});
            }
        })
        .catch(data => {
            this.setState({remoteImageError: `Server: ${data.error}`})
        })
    }
    GetRemoteImageUrl(appConfigId, key) {
        if (this.state.remoteImages === null) {
            return null;
        }
        for (let item of this.state.remoteImages) {
            if (item.appConfigId === appConfigId && item.key === key) {
                return item.location;
            }
        }
        return null;
    }
    render() {
        const { projectId, appConfig } = this.props;
        const appConfigId = appConfig[0].id;
        this.GetRemoteImageList(projectId, appConfigId);
        const api = `/api/data/project/${projectId}/appConfig/${appConfigId}/`
        return (
            <div className="imageForm">
                <div className="formEntry imgEntry">
                    <h3>App Icon</h3>
                    <div className="imgContainer">
                        <ImageUpload
                            name="appIcon192"
                            resolution={192}
                            instruction={`
                                icon .png: 192x192
                            `}
                            imgUrl={appConfig[0].appIcon192}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            fileSize={2097152}
                        />
                        <ImageUpload
                            name="appIcon432Fg"
                            resolution={432}
                            instruction={`
                                foreground .png: 432x432
                            `}
                            imgUrl={appConfig[0].appIcon432Fg}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            fileSize={2097152}
                        />
                        <ImageUpload
                            name="appIcon432Bg"
                            resolution={432}
                            instruction={`
                                background .png: 432x432
                            `}
                            imgUrl={appConfig[0].appIcon432Bg}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            fileSize={2097152}
                        />
                        <ImageUpload
                            name="notificationIcon"
                            resolution={48}
                            instruction={`
                                notification icon .png (pure white with transparent background): 48x48
                            `}
                            imgUrl={appConfig[0].notificationIcon}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            fileSize={2097152}
                        />
                    </div>
                </div>
                <div className="formEntry imgEntry">
                    <h3>Launch Splash Screen</h3>
                    <div className="imgContainer">
                        <ImageUpload
                            name="splashScreen"
                            instruction={`
                                .png (optional): 1280x1280
                            `}
                            imgUrl={appConfig[0].splashScreen}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            fileSize={2097152}
                        />
                    </div>
                </div>
                <div className="formEntry imgEntry">
                    <h3>Loading Screen Logo</h3>
                    <div className="imgContainer">
                        <ImageUpload
                            name="loadingScreenLogo"
                            instruction={`
                                .png (optional): 384x384
                            `}
                            imgUrl={appConfig[0].loadingScreenLogo}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            fileSize={2097152}
                        />
                    </div>
                </div>
                <div className="formEntry imgEntry">
                    <h3>Remote Images</h3>
                    <div className="imgContainer">
                        {this.state.remoteImages && this.state.remoteImages.map(remoteImage => (
                            <ImageUpload
                                noEdit={true}
                                name={"remoteImage/" + remoteImage.key}
                                instruction={remoteImage.key}
                                imgUrl={remoteImage.location}
                                api={api}
                                getAppConfig={this.props.getAppConfig}
                                fileSize={2097152}
                            />
                        ))}
                        <ImageUpload
                            name='REMOTE_IMAGE_PLACEHOLDER'
                            isRemoteImagePlaceholder={true}
                            instruction={`
                                .png: 1024x1024
                            `}
                            imgUrl={null}
                            api={api}
                            getAppConfig={this.props.getAppConfig}
                            remoteImages={this.state.remoteImages}
                            fileSize={2097152}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default ImageForm